import { forwardRef } from 'react';
import { ComboBoxInput } from './ComboBoxInput';
import { Box } from '../../Box';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveStyle = theme => ({
  display: 'flex',
  padding: '8px 0px',
  alignItems: 'center',
  alignContent: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch'
});
export const ComboBoxSingleSelect = /*#__PURE__*/forwardRef((props, ref) => {
  const theme = useInterstateTheme();
  const style = resolveStyle(theme);
  const {
    onInputFocus,
    onInputChange,
    onInputClick,
    selectedOptions,
    multiple,
    id,
    inputValue,
    ...rest
  } = props;
  const _selectedOption = selectedOptions[0] ? selectedOptions[0].label : inputValue;
  return /*#__PURE__*/_jsx(Box, {
    sx: style,
    className: 'ids-combo-box-multi-select-input',
    children: /*#__PURE__*/_jsx(ComboBoxInput, {
      ...props,
      ref: ref,
      onFocus: onInputFocus,
      onInputChange: onInputChange,
      onInputClick: onInputClick,
      value: _selectedOption,
      multiple: multiple,
      width: '100%',
      "data-testid": rest['data-testid'],
      id: id
    })
  });
});
ComboBoxSingleSelect.displayName = 'ComboBoxSingleSelect';